import request from '../utils/request';
//import request from '../utils/requestTest';

export function getTechniques(){
    return request({
      url: '/Technique',
      method: 'get',
    });
  }